import { ElementType } from "src/app/_core/models/ToolboxModel";
import { v4 as uuidv4 } from 'uuid';
import { IRect } from "src/app/_core/interfaces/IRect";
import { LayerLevel } from "../../interfaces/LayerLevel";
import { VerticalElement } from "../vertical-element";
import { AreaType, RectName } from "../../interfaces/IAreaType";
import { IPoint } from "../../interfaces/IPoint";
import { ProjectService } from "../../services/project.service";
import { IBomInfo } from "../../interfaces/IElement";
import { WizardParameter } from "../wizard/wizard-parameter.model";
import { Space } from "../space";

export class Obstacle extends VerticalElement {

  get leftX(): number {
    return this.rect.x;
  }
  get rightX(): number {
    return this.rect.x + this.rect.w;
  }
  get topY(): number {
    return this.rect.y;
  }
  get bottomY(): number {
    return this.rect.y + this.rect.h;
  }
  get optionName(): string {
    throw new Error("Method not implemented.");
  }
  getBomInfo(): IBomInfo {
    return null;
  }
  get name(): string {
		return $localize`:Common|Obstacle:Obstacle`;
  }


  get defMaxWidth(): number {
		return this.projectService.template.maxWidth;
	}
	get defMaxHeight(): number {
		return this.projectService.template.frontHeight;
	}
	get defMinWidth(): number {
		return 100;
	}
	get defMinHeight(): number {
		return 100;
	}

  get type(): ElementType {
    return ElementType.Obstacle;
  }

	public rectOnFront: IRect;
	public rectOnLeft: IRect;
	public rectOnRight: IRect;

  public get rectOnRear(): IRect {
    return this._rectOnRear;
  }
  public set rectOnRear(value: IRect) {
    this._rectOnRear = value;
  }

  get layer(): LayerLevel {
    return LayerLevel.Construction;
  }


  private currentArea: string;

  constructor(
    protected projectService: ProjectService,
    public area: AreaType = AreaType.Front,
    private def: WizardParameter,
    private space: Space,
    rectOnRoof: IRect = null,
    rectOnLeft: IRect = null,
    rectOnRight: IRect = null,
    rectOnFront: IRect = null,
    rectOnRear: IRect = null) {
    
    super(projectService);

    this.currentArea = RectName.get(this.area);

    this.rectOnLeft = rectOnLeft;
    this.rectOnFront = rectOnFront;
    this.rectOnRight = rectOnRight;
    this.rectOnRoof = rectOnRoof;
    this.rectOnRear = rectOnRear;

    this.id = "Obstacle_" + uuidv4();

  }

}
